module.exports = __webpack_public_path__ + "img/szlogo.31d345b7.png";